import { runtimeConfig } from "@/shared/config/runtime-config-loader";

export const API_URL = runtimeConfig.apiUrl;

export const USER_PREFERENCES_BASE_URL = `${API_URL}/user_preferences`;
export const GENERAL_BASE_URL = API_URL
